import { MemcmpFilter, PublicKey } from "@solana/web3.js";
import { bs58 } from "@coral-xyz/anchor/dist/cjs/utils/bytes";
import {
  ESCROW_DISCRIMINATOR,
  STAKING_DISCRIMINATOR,
  UNSTAKE_DISCRIMINATOR,
} from "../discriminator";

export * from "./staking_wrapper";
export * from "./escrow_wrapper";
export * from "./unstake_wrapper";

const IDL_DISCRIMINATOR_LENGTH = 8;

export function getStakingFilter(): MemcmpFilter {
  return {
    memcmp: {
      offset: 0,
      bytes: bs58.encode(STAKING_DISCRIMINATOR),
    },
  };
}

export function getEscrowFilter(): MemcmpFilter {
  return {
    memcmp: {
      offset: 0,
      bytes: bs58.encode(ESCROW_DISCRIMINATOR),
    },
  };
}

export function getUnstakeFilter(): MemcmpFilter {
  return {
    memcmp: {
      offset: 0,
      bytes: bs58.encode(UNSTAKE_DISCRIMINATOR),
    },
  };
}

export function getEscrowStakingFilter(staking: PublicKey): MemcmpFilter {
  return {
    memcmp: {
      offset: IDL_DISCRIMINATOR_LENGTH,
      bytes: staking.toBase58(),
    },
  };
}

export function getEscrowOwnerFilter(owner: PublicKey): MemcmpFilter {
  return {
    memcmp: {
      offset: IDL_DISCRIMINATOR_LENGTH + 32,
      bytes: owner.toBase58(),
    },
  };
}

export function getUnstakeOwnerFilter(owner: PublicKey): MemcmpFilter {
  return {
    memcmp: {
      offset: IDL_DISCRIMINATOR_LENGTH,
      bytes: owner.toBase58(),
    },
  };
}

export function getUnstakeEscrowFilter(escrow: PublicKey): MemcmpFilter {
  return {
    memcmp: {
      offset: IDL_DISCRIMINATOR_LENGTH + 32,
      bytes: escrow.toBase58(),
    },
  };
}

export function getUnstakeStakingFilter(staking: PublicKey): MemcmpFilter {
  return {
    memcmp: {
      offset: IDL_DISCRIMINATOR_LENGTH + 32 + 32,
      bytes: staking.toBase58(),
    },
  };
}
